// LocalPickr (localpickr.com): the customer-facing site that replaced "Offlico
// Find" (find.offlico.com) on 25 Oct 2026. Its website has its own repo,
// Rithik-bot/localpickr (~/Documents/localpickr), with its own copy of this
// file. This repo keeps only what its code still uses: the hosts of the
// cross-site redirect map (src/utils/siteDomains.js) and the name, description
// and share image of LocalPickr's sign-in (SignInPage through usePageSeo).
// Shared by the app and the build scripts: keep it free of React and browser
// globals.

export const OFFLICO_ORIGIN = "https://www.offlico.com";
export const LOCALPICKR_ORIGIN = "https://localpickr.com";
// LocalPickr's professional search (localpickr.com/search/); find.localpickr.com
// only redirects there.
export const LOCALPICKR_SEARCH_PATH = "/search/";
export const LOCALPICKR_FIND_HOSTNAME = "find.localpickr.com";
// Hosts that only redirect now (Render redirect-only static sites).
export const LEGACY_BUSINESS_HOSTNAME = "business.offlico.com";
export const LEGACY_FIND_HOSTNAME = "find.offlico.com";

export const LOCALPICKR = {
  name: "LocalPickr",
  description:
    "Find and book local mobile cleaners, gardeners, hairdressers, chiropodists and ear wax removal specialists who come to your home.",
  // LocalPickr's share image, served by its own site.
  ogImage: "https://localpickr.com/localpickr/og-image.png",
};

export function normalizeHostname(hostname) {
  return String(hostname || "").trim().toLowerCase().replace(/\.$/, "");
}
